import moment from "moment";

export default {
  collapseMenu(selector) {
    // reset 'open-menu' from all nav items
    document
      .querySelectorAll(".nav-parent")
      .forEach(element => element.classList.remove("open-menu"));

    if (selector) {
      const nav = document.getElementById(selector);
      if (nav && nav.classList) {
        nav.classList.add("open-menu");
      }
    }
  },
  setNavigationClass(selector) {
    // reset 'isActive' from all nav items
    document
      .querySelectorAll(".nav-master")
      .forEach(element => element.classList.remove("isActive"));

    if (selector) {
      // add 'isActive' inside anchor element
      const nav = document.getElementById(selector);
      if (nav && nav.classList) {
        nav.classList.add("isActive");
      }
    }

    // hide nav panel
    const navPanel = document.getElementsByClassName("left-menu");
    if (navPanel) {
      navPanel[0].classList.remove("isActive");
    }

    // hide overlay from screen
    document
      .getElementsByClassName("overlay")[0]
      .setAttribute("style", "display: none;");
  },
  fixDateTime(stringDate) {
    let result = null;
    if (stringDate !== null && stringDate !== undefined && stringDate !== "") {
      const periods = stringDate.split("-");
      result = {
        year: parseInt(periods[0]),
        month: parseInt(periods[1]),
        day: parseInt(periods[2])
      };
    }
    return result;
  },
  addDays(days) {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date;
  },
  addMonths(month) {
    const date = new Date();
    date.setMonth(date.getMonth() + month);
    return date;
  },
  toStringDate(date) {
    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "-" +
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate())
    );
  },
  validateForm(component, form, skipReset) {
    const self = this;
    const nodes = document.querySelectorAll(`#${form} :invalid`);
    const error = "validationErrors";
    let isSuccess = true;
    if (!skipReset) {
      Object.keys(component[error]).forEach(key => {
        component[error][key] = null;
      });
    }
    if (nodes.length > 0) {
      nodes.forEach(node => {
        if (node.title) {
          component[error][node.name] = node.title;
        } else {
          component[error][node.name] = node.validationMessage;
        }
        node.addEventListener("change", function(e) {
          self.validateForm(component, form);
        });
      });
      isSuccess = false;
    }
    return isSuccess;
  },
  isEmpty(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  },
  redirectToServerError(component) {
    component.$router.push({
      name: "500"
    });
  },
  toJavascriptDateTime(stringDateTime) {
    if (stringDateTime === undefined) {
      return null;
    }
    let rawDateTimes = stringDateTime.split("-"); // yyyy.MM.dd-HH.mm
    let dates = rawDateTimes[0].split("."); // yyyy.MM.dd
    let times = rawDateTimes[1].split("."); // HH.mm
    return new Date(
      parseInt(dates[0]),
      parseInt(dates[1]),
      parseInt(dates[2]),
      parseInt(times[0]),
      parseInt(times[1]),
      0
    );
  },
  toMaverickDateTime(stringDateTime) {
    if (stringDateTime === undefined) {
      return null;
    }
    let rawDateTimes = stringDateTime.split("-"); // yyyy.MM.dd-HH.mm
    let dates = rawDateTimes[0].split("."); // yyyy.MM.dd
    let times = rawDateTimes[1].split("."); // HH.mm
    return {
      year: parseInt(dates[0]),
      month: parseInt(dates[1]),
      day: parseInt(dates[2]),
      hour: parseInt(times[0]),
      minute: parseInt(times[1])
    };
  },
  toDateString(maverickDateTime, format) {
    return moment(
      new Date(
        maverickDateTime.year,
        maverickDateTime.month - 1,
        maverickDateTime.day,
        maverickDateTime.hour,
        maverickDateTime.minute
      )
    ).format(format);
  },
  alphabetsOnly() {
    const alphabetElements = document.getElementsByClassName("alphabets-only");
    for (let i = 0; i < alphabetElements.length; i++) {
      alphabetElements[i].addEventListener("keypress", function() {
        const key = String.fromCharCode(
          !event.charCode ? event.which : event.charCode
        );
        if (!new RegExp("^[a-zA-Z ]+$").test(key)) {
          event.preventDefault();
          return false;
        }
      });
    }
  },
  alphabetsCharactersOnly() {
    const alphabetElements = document.getElementsByClassName(
      "alphabets-characters-only"
    );
    for (let i = 0; i < alphabetElements.length; i++) {
      alphabetElements[i].addEventListener("keypress", function() {
        const key = String.fromCharCode(
          !event.charCode ? event.which : event.charCode
        );
        // if (!new RegExp("^[a-zA-Z ]+$").test(key)) {
        if (!new RegExp(`^[a-zA-Z .'\\/-]+$`).test(key)) {
          event.preventDefault();
          return false;
        }
      });
    }
  },
  // numbersOnly() {
  //   const numericElements = document.getElementsByClassName("numbers-only");
  //   for (let i = 0; i < numericElements.length; i++) {
  //     numericElements[i].addEventListener("keypress", function() {
  //       const key = String.fromCharCode(
  //         !event.charCode ? event.which : event.charCode
  //       );
  //       if (!new RegExp("^[0-9]+$").test(key)) {
  //         event.preventDefault();
  //         return false;
  //       }
  //     });
  //   }
  // },
  numbersOnly() {
    const numericElements = document.getElementsByClassName("numbers-only");
    for (let i = 0; i < numericElements.length; i++) {
      numericElements[i].addEventListener("keypress", function(event) {
        const key = String.fromCharCode(
          !event.charCode ? event.which : event.charCode
        );

        const currentValue = this.value;
        const newValue = currentValue + key;
        const regex = /^[0-9]+$/;

        if (!regex.test(newValue)) {
          event.preventDefault();
          return false;
        }
      });

      numericElements[i].addEventListener("input", function(event) {
        this.value = this.value.replace(/[^0-9]/g, "");
      });
    }
  },
  numbersCurrency() {
    const numericElements = document.getElementsByClassName("numbers-currency");
    for (let i = 0; i < numericElements.length; i++) {
      numericElements[i].addEventListener("keypress", function(event) {
        const key = String.fromCharCode(
          !event.charCode ? event.which : event.charCode
        );

        const currentValue = this.value;
        const newValue = currentValue + key;
        const regex = /^-?[0-9]*[.,]?[0-9]*$/;

        if (!regex.test(newValue)) {
          event.preventDefault();
          return false;
        }
      });

      numericElements[i].addEventListener("input", function(event) {
        let value = this.value;

        const parts = value.split(/[.,]/);
        if (parts.length > 2) {
          this.value = parts[0] + "." + parts.slice(1).join("");
        }

        if (value.indexOf("-") > 0) {
          this.value = value.replace(/-/g, "");
        }
        this.value = this.value.replace(/(?!^)-/g, "");
      });
    }
  },
  alphabetsNumbersOnly() {
    const alphabetElements = document.getElementsByClassName(
      "alphabets-numbers-only"
    );
    for (let i = 0; i < alphabetElements.length; i++) {
      alphabetElements[i].addEventListener("keypress", function() {
        const key = String.fromCharCode(
          !event.charCode ? event.which : event.charCode
        );
        if (!new RegExp(`[a-zA-Z0-9]`).test(key)) {
          event.preventDefault();
          return false;
        }
      });
    }
  },
  disableContextMenu(element) {
    $(element).on("contextmenu", _ => false);
  },
  getPlaceIcon(types, description = "") {
    switch (true) {
      case types.includes("airport") ||
        description.toLowerCase().includes("airport"):
        return "<i class='ic-flight-landing'></i>";
      case types.includes("restaurant"):
      case types.includes("food"):
      case types.includes("cafe"):
        return "<i class='ic-meal'></i>";
      case types.includes("store"):
      case types.includes("shopping_mall"):
        return "<i class='ic-briefcase'></i>";
      case types.includes("lodging"):
        return "<i class='ic-bed'></i>";
      case types.includes("bus_station"):
        return "<i class='ic-bus'></i>";
      case types.includes("train_station"):
      case types.includes("transit_station"):
        return "<i class='ic-train'></i>";
      case types.includes("school"):
      case types.includes("university"):
      case types.includes("hospital"):
        return "<i class='ic-office'></i>";
      case types.includes("gym"):
        return "<i class='ic-fitness'></i>";
      default:
        return "<i class='ic-marker-maps'></i>";
    }
  },
  humanize(text) {
    if (text && text !== "") {
      const formattedText = text.replace(/([A-Z])/g, " $1");
      const result =
        formattedText.charAt(0).toUpperCase() + formattedText.slice(1);
      return result.trim();
    }
    return text;
  },
  printFileSize(size) {
    if (size < 1000000) {
      return `${(size / 1000).toFixed(0)} KB`;
    } else {
      return `${(size / 1000000).toFixed(2)} MB`;
    }
  },
  extractSetting(items, key, defaultValue) {
    if (defaultValue === undefined) {
      defaultValue = null;
    }
    try {
      const setting = items.find(x => x.key === key);
      return setting ? setting.value : defaultValue;
    } catch (error) {
      return defaultValue;
    }
  },
  emptyGuid() {
    return "00000000-0000-0000-0000-000000000000";
  },
  getEventDescription(history, userType = "Unspecified") {
    let historyStrings = [];

    // append creator name
    if (
      history.createdBy &&
      history.createdBy !== "" &&
      userType === "TenantUser"
    ) {
      historyStrings.push(`User: ${history.createdBy}`);
    }

    // display provider/vehicle/driver/passenger
    if (
      history.event.toLowerCase().includes("providerfullyconfirmed") &&
      history.provider
    ) {
      if (history.provider) {
        historyStrings.push(`Provider: ${history.provider.name}`);
      }
      if (history.driver) {
        historyStrings.push(
          `Driver: ${history.driver.title ? history.driver.title : ""} ${
            history.driver.fullName ? history.driver.fullName : ""
          }`
        );
      }
      if (history.vehicle) {
        historyStrings.push(
          `Vehicle: ${
            history.vehicle.factoryName ? history.vehicle.factoryName : ""
          } ${history.vehicle.brandName ? history.vehicle.brandName : ""}`
        );
      }
    } else if (
      history.event.toLowerCase().includes("provider") &&
      history.provider
    ) {
      historyStrings.push(`Provider: ${history.provider.name}`);
    } else if (
      history.event.toLowerCase().includes("driver") &&
      history.driver
    ) {
      historyStrings.push(
        `Driver: ${history.driver.title ? history.driver.title : ""}. ${
          history.driver.fullName ? history.driver.fullName : ""
        }`
      );
    } else if (
      history.event.toLowerCase().includes("vehicle") &&
      history.vehicle
    ) {
      historyStrings.push(
        `Vehicle: ${
          history.vehicle.factoryName ? history.vehicle.factoryName : ""
        } ${history.vehicle.brandName ? history.vehicle.brandName : ""}`
      );
    } else if (
      history.event.toLowerCase().includes("passenger") &&
      history.customer
    ) {
      historyStrings.push(
        `Passenger: ${history.customer.title ? history.customer.title : ""} ${
          history.customer.fullName ? history.customer.fullName : ""
        }`
      );
    }

    // append description
    if (history.description && history.description !== "") {
      // temp comment
      // let descriptionSplit = history.description.split("/");
      // let description = descriptionSplit[descriptionSplit.length - 1];
      if (history.event.toLowerCase() === "paid") {
        historyStrings.push(
          `<span style="word-break: break-word;">${history.description}</span>`
        );
      } else if (userType !== "CorporateUser") {
        historyStrings.push(
          `Description: <span style="word-break: break-word;">${history.description}</span>`
        );
      }
    }

    let result = "";
    for (let i = 0; i < historyStrings.length; i++) {
      const item = historyStrings[i];
      result += item;
      if (i < historyStrings.length - 1) {
        result += "<br/>";
      }
    }

    return result;
  },
  fromMinutestoMilliseconds(minutes) {
    return minutes * 60000;
  },
  scrollTop() {
    document.documentElement.scrollTop = 0;
  },
  focusToFieldError(form = null) {
    const fieldError = form
      ? form.querySelector(".field-error")
      : document.querySelector(".field-error");

    if (fieldError) {
      fieldError.scrollIntoView({ behavior: "smooth" });
    }
  },
  prependToArray(value, array) {
    const newArray = array.slice();
    newArray.unshift(value);
    return newArray;
  },
  isNotExpiredDate(utcPickUpDateTimeOffset) {
    const _datetimeOffsetDiff =
      Date.parse(utcPickUpDateTimeOffset) -
      Date.parse(new Date().toUTCString());
    return _datetimeOffsetDiff >= 0;
  },
  printServiceType(type) {
    switch (type) {
      case 1:
        return "Transfer";

      case 2:
        return "Rental";

      default:
        return "Unspecified";
    }
  },
  printRangeOfHour(start, end) {
    if (start === 0) {
      if (end === 0) {
        return `-`;
      }
      return `Less than ${end} hours`;
    } else {
      if (end === null || end === -1) {
        return `${start} hours or more`;
      } else {
        return `${start} hours and ${end} hours`;
      }
    }
  },
  printWaitingTimeSourceType(type) {
    switch (type) {
      case 1:
        return "Airport Arrival";

      case 2:
        return "Non-Airport Arrival";

      case 3:
        return "Extra Stop";

      case 4:
        return "Extra Stop Waiting Time";

      default:
        return "Unspecified";
    }
  },
  formatDateTime(date) {
    const optionDay = {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric"
    };
    const dates = new Intl.DateTimeFormat("en-GB", optionDay).format(date);
    const minutes = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
    const hour = date.getHours();

    return `${dates} ${hour}:${minutes}`;
  },
  dateUKFormatted(inputDate) {
    return moment(inputDate)
      .parseZone()
      .format("D/MM/YYYY");
  },
  dateFormatted(inputDate) {
    return moment(inputDate)
      .parseZone()
      .format("MMMM D, YYYY");
  },
  timeFormatted(inputTime) {
    return moment(inputTime)
      .parseZone()
      .format("HH:mm");
  },
  timeFormattedFull(inputTime) {
    return moment(inputTime)
      .parseZone()
      .format("HH:mm:ss");
  },
  printAddressName(address) {
    const firstAddress = address.split(",")[0];
    return firstAddress;
  }
};



// WEBPACK FOOTER //
// ./src/plugins/global.js